class WatchRepairRequest extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('.js-watch-repair-request')
    this.accept = this.querySelector('#js-watch-repair-request-accept')
  }

  connectedCallback() {
    this.onClickHandler = this.onClickHandler.bind(this)
    this.input.addEventListener('click', this.onClickHandler)
    this.onCheckHandler = this.onCheckHandler.bind(this)
    this.accept.addEventListener('change', this.onCheckHandler)
  }

  disconnectedCallback() {
    this.input.removeEventListener('click', this.onClickHandler)
    this.accept.removeEventListener('change', this.onCheckHandler)
  }

  onClickHandler(e) {
    location.href = this.input.dataset.href
  }

  onCheckHandler(e) {
    if(this.accept.checked)
      this.input.removeAttribute('disabled')
    else
      this.input.setAttribute('disabled', true)
  }
}

customElements.define('watch-repair-request', WatchRepairRequest)
